// extracted by mini-css-extract-plugin
export default {"createSection":"styles_createSection__GNSTH"};